import Accordion from 'accordion-js'

// Event delegation — no timing dependency, works regardless of when script runs
document.addEventListener('click', (e) => {
  if (!e.target.closest('.mobile-header__menu-icon')) return

  const navTrigger = document.querySelector('.mobile-header__menu-icon')
  const navWrap = document.querySelector('.mobile-header__wrap')
  const dropdownsWrap = document.querySelector('.main-menu-mobile__dropdowns')
  const searchTrigger = document.querySelector('.mobile-header__search')
  const searchWrap = document.querySelector('.mobile-header__search-bar')

  searchTrigger?.classList.remove('is-open')
  searchWrap?.classList.remove('is-open')

  const isOpen = navTrigger.classList.contains('is-open')
  navTrigger.classList.toggle('is-open', !isOpen)
  navWrap?.classList.toggle('is-open', !isOpen)
  dropdownsWrap?.classList.toggle('is-open', !isOpen)
})

const searchTrigger = document.querySelector('.mobile-header__search')
const searchWrap = document.querySelector('.mobile-header__search-bar')

searchTrigger?.addEventListener('click', () => {
  const navTrigger = document.querySelector('.mobile-header__menu-icon')
  const navWrap = document.querySelector('.mobile-header__wrap')
  const dropdownsWrap = document.querySelector('.main-menu-mobile__dropdowns')

  navTrigger?.classList.remove('is-open')
  navWrap?.classList.remove('is-open')
  dropdownsWrap?.classList.remove('is-open')

  searchTrigger.classList.toggle('is-open')
  searchWrap?.classList.toggle('is-open')
})

const subcategoryDropdowns = [...document.querySelectorAll('.main-menu-mobile__dropdown')]
  .filter((dropdown) => dropdown.querySelector('.main-menu-mobile__subcategory-wrap--has-dropdown'))
  .map((dropdown) => ({
    el: dropdown,
    accordion: new Accordion(dropdown, {
      elementClass: 'main-menu-mobile__subcategory-wrap--has-dropdown',
      triggerClass: 'main-menu-mobile__dropdown__subcategory-icon',
      panelClass: 'main-menu-mobile__dropdown__subcategory-items',
      activeClass: 'is-open',
    }
  )}))

new Accordion('.main-menu-mobile__dropdowns', {
  elementClass: 'main-menu-mobile__dropdown-wrap--has-dropdown',
  triggerClass: 'main-menu-mobile__category-icon',
  panelClass: 'main-menu-mobile__dropdown',
  activeClass: 'is-open',
  beforeClose: (el) => {
    const panelId = el.id.split('-').join('-panel-')
    const subcategoryDropdown = subcategoryDropdowns.find((dropdown) => dropdown.el.id === panelId)

    if (!subcategoryDropdown) return

    subcategoryDropdown.accordion.closeAll()

    // Below we are manually toggling false aria-expanded's due to a bug with
    // manually closing dropdowns with accordion-js
    const expandedAreas = [...subcategoryDropdown.el.querySelectorAll('[aria-expanded="true"]')]
    if (expandedAreas) {
      expandedAreas.forEach((expanded) => expanded.setAttribute('aria-expanded', false))
    }
  }
})
